import { motion } from "framer-motion";
import { ProductCard } from "./ProductCard";

export const ProductShowcase = ({ products, content, onOpen, onRegister, onCompare }) => {
  const section = content.productsSection;
  const description = section.description
    .replace("{count}", products.length)
    .replace("{models}", products.length === 1 ? "model" : "models");
  return (
    <section
      id="models"
      data-testid="product-showcase"
      className="relative py-14 sm:py-20 lg:py-28"
    >
      <div className="absolute inset-0 grid-bg opacity-25" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-9 sm:mb-14 lg:mb-20"
        >
          <span className="section-kicker justify-center mb-3 sm:mb-4">{section.kicker}</span>
          <h2 className="font-display font-bold text-3xl sm:text-5xl">
            {section.title}
          </h2>
          <p className="mt-3 sm:mt-5 text-white/60 leading-relaxed">
            {description}
          </p>
          <div className="mt-5 sm:mt-7 flex flex-wrap justify-center gap-2">
            {products.slice(0, 6).map((product) => (
              <span key={product.id} className="border border-white/15 bg-white/[0.03] px-3 py-1.5 text-xs text-white/68 rounded-full">
                {product.name}
              </span>
            ))}
          </div>
        </motion.div>

        <div className="space-y-12 sm:space-y-16 lg:space-y-24">
          {products.map((p, i) => (
            <ProductCard
              key={p.id}
              product={p}
              actions={content.actions}
              productLabels={content.productLabels}
              index={i}
              onOpen={onOpen}
              onRegister={onRegister}
              onCompare={onCompare}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;
